import { paths } from '@luxuryescapes/contract-svc-lux-loyalty'
import requestUtils from 'api/requestUtils'

type Payload = paths['/api/lux-loyalty/points/calculate-earn']['post']['parameters']['body']['payload']
type Response = paths['/api/lux-loyalty/points/calculate-earn']['post']['responses']['200']['content']['application/json']

function loyaltyServerProductDetailsMap(options: App.LoyaltyPointsEarnCalculationRequest): Payload['productDetails'] {
  if (
    options.loyaltyProductType === 'hotel_flash' ||
    options.loyaltyProductType === 'hotel_lpc' ||
    options.loyaltyProductType === 'rental' ||
    options.loyaltyProductType === 'le_tour' ||
    options.loyaltyProductType === 'trusted_partner_tour' ||
    options.loyaltyProductType === 'tour_bank' ||
    options.loyaltyProductType === 'cruise_group_1' ||
    options.loyaltyProductType === 'cruise_group_2' ||
    options.loyaltyProductType === 'cruise_group_3'
  ) {
    return {
      loyaltyProductType: options.loyaltyProductType,
      offerId: options.offerId,
      packageId: options.packageId,
    }
  }

  return {
    loyaltyProductType: options.loyaltyProductType,
  }
}

interface Options {
  customerId: string;
  currency: string;
  luxPlusMember: boolean;
}

async function requestLoyaltyEarnPointsCalculation(request: App.LoyaltyPointsEarnCalculationRequest, options: Options): Promise<App.LoyaltyPointsEarnCalculation> {
  const payload: Payload = {
    publicPrice: request.price,
    luxPlusPrice: request.memberPrice,
    luxPlusMember: options.luxPlusMember,
    currency: options.currency,
    mx: request.mx,
    customerId: options.customerId,
    bypassCache: request.bypassCache,
    productDetails: loyaltyServerProductDetailsMap(request),
  }

  const response = await requestUtils.post<Response, Payload>('/api/lux-loyalty/points/calculate-earn',
    payload,
    { credentials: 'include' },
  )

  const basePoints = response.result.totalBasePoints
  const bonusPoints = response.result.totalBonusPoints
  const statusCredits = response.result.totalStatusCredits
  const appliedRuleIds = response.result.appliedCustomRuleIds

  return {
    request,
    points: basePoints + bonusPoints,
    basePoints,
    bonusPoints,
    statusCredits,
    appliedRuleIds,
  }
}

export default requestLoyaltyEarnPointsCalculation
